import React from 'react'
import { motion } from 'framer-motion';
import ResumeCard from './ResumeCard';

const Education = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      {/* part one */}
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2015 - 2024</p>
          <h2 className="text-3xl md:text-4xl font-bold">Education Quality</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="B.A (Hons) Animal Science"
            subTitle="Kano University of Science and Technology Wudil (2017 - 2024)"
            result="3.88/5"
            des="Learn, Work and Worship so as to be a good Alumni of KUST Wudil."
          />
          <ResumeCard
            title="Full Stack Web Development"
            subTitle="Udemy Web Development Bootcamp (2021 - 2023)"
            result="Credit"
            des="A well structured course that equips me with the knowledge of web development since from scratch."
          />
          <ResumeCard
            title="Three Million Tech Talent Nigeria (3MTT)"
            subTitle="Product Dive Lagos (2023 - 2024)"
            result="Credit"
            des="A great School that provides me with a full knowledge of product management since from requirement gathering."
          />
        </div>
      </div>
    </motion.div>
  );
}

export default Education